import { useMemo } from "react";
import Loader from "../../../../components/Loader";
import usePagination from "../../../../hooks/usePagination";
import Pagination from "../../../../components/Pagination/Pagination";
import InnerBannerBreadcrumb from "../../../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import {
  convertDateFormat,
  getLatestDateFromData,
} from "../../../../Utils/utils";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useLanguageTranslation } from "../../../../hooks/useLanguageTranslation";
import { useGetProtectedApiDataQuery } from "../../../../redux/services/apiSlice";
import PageLastUpdated from "../../../../components/shared/PageLastUpdated";

const PublicationDetailPage = () => {
  const navigate = useNavigate();
  const { languageType } = useSelector((state) => state.homeSlice);

  const { data: publicationsData = [], isLoading: publicationsIsLoading } =
    useGetProtectedApiDataQuery({ url: "publication", lang: languageType });
  const { getText } = useLanguageTranslation();

  const lastUpdatedOn = useMemo(() => {
    return getLatestDateFromData(publicationsData);
  }, [publicationsData]);

  const handlePublicationClick = (item) => {
    if (item.field_publications_document !== "") {
      navigate(`/publication-detail/${item.nid}`);
    } else {
      window.open(
        `${process.env.REACT_APP_IMAGE_URL}/${item.field_covid_document}`,
        "_blank",
        "noopener,noreferrer"
      );
    }
  };

  const { currentItems, currentPage, totalPages, handlePageChange } =
    usePagination(publicationsData, 12);

  if (publicationsIsLoading) {
    return <Loader />;
  }

  return (
    <>
      <InnerBannerBreadcrumb
        bannerImage="images/inner_aboutbann.jpg"
        title={getText("News Room & Media", "समाचार मीडिया")}
        titleTwo={getText("Publications", "प्रकाशन")}
        titleLink="/publication-detail"
        levelTwo={true}
        levelThree={false}
        isActive={getText("Publications", "प्रकाशन")}
      />

      <div className="inner-container">
        <div className="container">
          <section className="ourCompany">
            <div className="container">
              <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />
              <div className="row mb-5">
                {currentItems.map((publicationItem, index) => (
                  <div
                    className="col-12 col-sm-12 col-md-3 col-lg-3 mvDescWrap mb-3"
                    key={index}
                  >
                    <div className="photo-gallery-area desc-sec photo-gallery-detail-page publicationslist">
                      <div className="card-sec">
                        <div
                          className="img-sec"
                          onClick={(e) =>
                            handlePublicationClick(publicationItem)
                          }
                        >
                          <a
                            // href={`${process.env.REACT_APP_IMAGE_URL}/${publicationItem?.field_covid_document}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              src={`${process.env.REACT_APP_IMAGE_URL}/${publicationItem?.nothing}`}
                              alt={publicationItem?.title}
                            />
                          </a>
                        </div>
                        <div className="pdf-link">
                          <a
                            // href={`${process.env.REACT_APP_IMAGE_URL}/${publicationItem?.field_covid_document}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              src="./images/pdf-icon.png"
                              alt="PDF-Icon"
                              className="mr-2"
                            />
                          </a>
                        </div>
                        <div className="desc-sec">
                          <div>
                            <span className="date">
                              {convertDateFormat(
                                publicationItem?.field_date_of_publication
                              )}
                            </span>

                            {publicationItem?.field_publication_vol && (
                              <span className="vol-txt">
                                {publicationItem.field_publication_vol}
                              </span>
                            )}
                          </div>
                          <p>
                            {
                              publicationItem.title
                              // .slice(0, 20)
                            }
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
              />
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default PublicationDetailPage;
